<script>
import classes from '~~/common/vue/mixins/classes';

// TODO: refactor and rename to `variant`
export const colors = ['primary', 'secondary', 'white', 'dark', 'bare', 'result'];

export default {
  name: 'ELink',
  mixins: [classes],
  props: {
    as: {
      type: String,
      default: 'a',
      cssClass: true,
    },
    // TODO: refactor and rename to `variant`
    color: {
      type: String,
      default: colors[0],
      cssClass: true,
      validator: (value) => colors.includes(value),
    },
  },
  render(create) {
    const attrs = {};
    if (this.as !== 'a') {
      attrs.role = 'button';
    }
    const options = {
      class: this.classes,
      attrs: { ...attrs, ...this.$attrs },
      on: this.$listeners,
    };
    return create(this.as, options, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped>
$colors: (
  "primary": $blue-50,
  "secondary": $gray-40,
  "white": $white,
  "dark": $gray-60,
  "result": $color-link-results-default,
);

.link {
  text-decoration: none;
  transition: color $timing-2s $easing;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}

@each $name, $color in $colors {
  .link--color-#{$name} {
    color: $color;
  }
}

.link--color-bare {
  color: $gray-40;

  &:hover,
  &:focus {
    color: $gray-60;
  }
}

.link--color-result {
  &:visited {
    color: $color-link-results-visited;
  }
}

.link--as-button {
  appearance: none;
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  font: inherit;
  text-transform: none;
}
</style>
